export default function formatArticle({ meta: { url } = {}, y }) {
  if (!url) return y
  return (
    <a target="_blank" rel="noopener noreferrer" href={url}>
      {y}
    </a>
  )
}
